import { render, staticRenderFns } from "./TextIconList.vue?vue&type=template&id=048b7e28&scoped=true"
import script from "./TextIconList.vue?vue&type=script&lang=js"
export * from "./TextIconList.vue?vue&type=script&lang=js"
import style0 from "./TextIconList.vue?vue&type=style&index=0&id=048b7e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b7e28",
  null
  
)

export default component.exports